import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
import styles from "./About.module.css";

const About = (props) => {
  useEffect(() => {
    props.newColor("--about-color");
  });

  // time calculations
  const d = new Date();
  const [y, m] = [d.getFullYear(), d.getMonth()];
  const age = m < 11 ? y - 1993 : y - 1992;

  // footer handlers
  const showMail = () => props.setMailText(true);
  const hideMail = () => props.setMailText(false);
  const showCall = () => props.setCallText(true);
  const hideCall = () => props.setCallText(false);

  // paragraph fade in animation
  const [pFadeIn, setPFadeIn] = useState(0);
  useEffect(() => {
    const pFadeInInterval = setInterval(() => {
      if (pFadeIn < bodyText.length) {
        setPFadeIn(pFadeIn + 1);
      }
    }, 750);
    return () => clearInterval(pFadeInInterval);
  }, [pFadeIn]);

  const bodyText = [
    <>
      My name is Devin Wright. I'm a {age}-year-old software developer
      specializing in Python and JavaScript applications.
    </>,
    <>
      My experience includes web-based systems with Django, React, and Angular,
      integrating RESTful APIs with MySQL and MongoDB backends, and deploying
      services within cloud-based environments. I focus on correctness,
      maintainability, and clear system structure.
    </>,
    <>
      In parallel with software development, I have tutored advanced mathematics
      and technical subjects at the college level since 2017. This background
      informs my engineering work by emphasizing precision, logical structure,
      and explainability.
    </>,
    <>
      I hold AWS Solutions Architect and ServiceNow System Administrator
      certifications and continue to build production-oriented applications.
    </>,
    <>
      If you're an employer interested in working with me, I encourage you to
      download a copy of my{" "}
      <a href={`${process.env.PUBLIC_URL}/Devin Wright - Resume.pdf`}>resume</a>{" "}
      for your records. Please also feel free to reach out to me by{" "}
      <a href="tel:18452764609" onMouseEnter={showCall} onMouseLeave={hideCall}>
        phone
      </a>{" "}
      or{" "}
      <a
        href="mailto:devin.wright.software@gmail.com"
        onMouseEnter={showMail}
        onMouseLeave={hideMail}
        target="_blank"
        rel="noopener noreferrer"
      >
        email
      </a>{" "}
      with any questions.
    </>,
  ];

  return (
    <div className={styles.About}>
      <div style={{ maxWidth: "500px", margin: "100px auto" }}>
        <div className="mx-4">
          <h1 className="display-1">Greetings!</h1>
          <div>
            {bodyText.map((paragraph, i) => {
              return (
                <p
                  className={`${
                    i >= pFadeIn ? styles.hidden : styles.fadeInUp
                  }`}
                  key={`paragraph${i + 1}`}
                >
                  {paragraph}
                </p>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

About.propTypes = {};

About.defaultProps = {};

export default About;
